import React from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { ZariContext } from '_zari/context'
import { Button, Form, Col, Row, Divider } from '_zari/core'

import {
  CodigosTransaccionesConstant,
  CondicionesPagoConstant,
  MonedasConstant,
  TiposDocumentoIdentificacionConstant,
  TiposDocumentoSunatConstant,
  TiposProductoConstant,
  MontosIcbper
} from 'constants/index'

import { IdGen, RounderUtil, ZrSwal } from 'utils'

import * as FacturacionService from 'services/facturacion.service'
import * as PromocionService from 'services/promocion.service'
import * as SocioService from 'services/socio.service'
import * as StockService from 'services/stock.service'
import * as CompaniaService from 'services/compania.service'

import * as FormGroups from './formGroups'
import * as Modals from './modals'
import * as Sections from './sections'

import { ValidationSchema } from './validation'
import commonReducer from './reducer'

const RESUMEN_MONTOS_INITIAL_VALUES = {
  sumaInafecto: 0,
  sumaExonerado: 0,
  sumaGratuito: 0,
  sumaGravado: 0,
  sumaIgv: 0,
  sumaDescuento: 0,
  sumaIcbper: 0,
  sumaAnticipo: 0,
  sumaTotal: 0
}

const EstandarView = ({
  editarData,
  flagEditar,
  flagNota,
  flagEditarComentarios,
  flagSinEntrega,
  flagVentaRapida,
  flagNuevaNota,
  flagDuplicado,
  flagAnular,
  codigoTransaccion,
  reiniciarFormulario
}) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const [detalles, detallesDispatcher] = React.useReducer(commonReducer, editarData.detalles, inputArr => {
    if (inputArr) {
      const salida = inputArr.map(x => ({
        ...x,
        afectacionBase: x.afectacion,
        __filaActiva: false,
        __focusCantidad: false,
        __focusDescuento: false,
        __focusPrecio: false,
        esFilaBusqueda: false,
        _idFila: IdGen.newId()
      }))

      if (flagEditarComentarios) {
        return salida
      }
      return [...salida, { __filaActiva: true, esFilaBusqueda: true, _idFila: IdGen.newId() }]
    }
    return [{ __filaActiva: true, esFilaBusqueda: true, _idFila: IdGen.newId() }]
  })

  const [__keyResumenMontos, setKeyResumenMontos] = React.useState(IdGen.newId())
  const [__keyDetalles, setKeyDetalles] = React.useState(IdGen.newId())
  const [flagPermitirVentaSinStock, setFlagPermitirVentaSinStock] = React.useState(false)
  const [mostrarBotonRecalcular, setMostrarBotonRecalcular] = React.useState(false)
  const [mostrarConsultarDocumentoModal, setMostrarConsultarDocumentoModal] = React.useState(false)
  const [mostrarDocumentosAnticiposModal, setMostrarDocumentosAnticiposModal] = React.useState(false)
  const [mostrarListaGuiasModal, setMostrarListaGuiasModal] = React.useState(false)
  const [mostrarListaPreVentasModal, setMostrarListaPreVentasModal] = React.useState(false)
  const [mostrarFormularioPagosModal, setMostrarFormularioPagosModal] = React.useState(false)
  const [mostrarAsignacionCuotasModal, setMostrarAsignacionCuotasModal] = React.useState(false)
  const [mostrarPreviewPdfModal, setMostrarPreviewPdfModal] = React.useState(false)

  const mainFormikRef = React.useRef(null)
  const resumenMontosRef = React.useRef(RESUMEN_MONTOS_INITIAL_VALUES)
  const submitDataRef = React.useRef({})
  const firstRefreshRef = React.useRef(false)
  const idClienteVariosRef = React.useRef(null)
  const pdfHashRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    let condicionPago = editarData.condicionPago || CondicionesPagoConstant.CONTADO
    let tipoDocumento = editarData.tipoDocumento || TiposDocumentoSunatConstant.BOLETA
    let serieDocumento = editarData.serieDocumento || ''
    let numeroDocumento = editarData.numeroDocumento || ''
    let fechaEmision = editarData.fechaEmision || __adminContext.fechaTrabajo || ''
    let fechaVencimiento = editarData.fechaVencimiento || __adminContext.fechaTrabajo || ''
    let _idDocumentoNota = editarData._idDocumentoNota || ''
    let modificadoTipoDocumento = editarData.modificadoTipoDocumento || ''
    let modificadoSerieDocumento = editarData.modificadoSerieDocumento || ''
    let modificadoNumeroDocumento = editarData.modificadoNumeroDocumento || ''

    if (flagNuevaNota) {
      condicionPago = editarData.condicionPago || CondicionesPagoConstant.CONTADO
      tipoDocumento = TiposDocumentoSunatConstant.NOTA_CREDITO
      serieDocumento = ''
      numeroDocumento = ''
      fechaEmision = __adminContext.fechaTrabajo

      modificadoTipoDocumento = editarData.tipoDocumento
      modificadoSerieDocumento = editarData.serieDocumento
      modificadoNumeroDocumento = editarData.numeroDocumento
      fechaVencimiento = fechaEmision
    }

    return {
      _id: editarData._id || '',
      _idDocumentoNota: _idDocumentoNota,
      _idHistorialNota: editarData._idHistorialNota || '',
      idsAnticipos: editarData.idsAnticipos || [],
      _idDireccionSocio: editarData._idDireccionSocio || '',
      _idModeloCuentas12: editarData._idModeloCuentas12 || '',
      _idListaPrecio: editarData._idListaPrecio || __adminContext.valoresConfiguracionSede._idListaPrecio || '',
      _idPedido: editarData._idPedido || '',
      _idPedidoEcommerce: editarData._idPedidoEcommerce || '',
      _idPreFacturacion: editarData._idPreFacturacion || '',
      _idPlacaSocio: editarData._idPlacaSocio || '',
      _idPlantillaComentario: editarData._idPlantillaComentario || '',
      _idSocio: editarData._idSocio || '',
      _idVendedor: editarData._idVendedor || '',
      codigoSocio: editarData.codigoSocio || '',
      cantidadCuotas: editarData.cantidadCuotas || '',
      codigoDetraccion: editarData.codigoDetraccion || '',
      codigoTransaccion: codigoTransaccion,
      comentario: editarData.comentario || '',
      condicionPago: condicionPago,
      cuotas: editarData.cuotas || null,
      documentoSocio: editarData.documentoSocio || '',
      fechaEmision: fechaEmision,
      fechaVencimiento: fechaVencimiento,
      flagSinEntrega: flagSinEntrega,
      flagVentaRapida: flagVentaRapida,
      flagSerieContingencia: editarData.flagSerieContingencia ?? false,
      flagPorGuias: editarData.flagPorGuias || false,
      flagPreVenta: editarData.flagPreVenta || false,
      incluyeIGV: editarData.incluyeIGV ?? __adminContext.valoresConfiguracionUsuario.flagFacturacionConIGV ?? true,
      infosAnticipos: editarData.infosAnticipos || [],
      moneda: editarData.moneda || MonedasConstant.SOLES,
      montoAnticipo: editarData.montoAnticipo || 0,
      motivo: editarData.motivo || '',
      nombreAlternativoSocio: editarData.nombreAlternativoSocio || '',
      nombreSocio: editarData.nombreSocio || '',
      numeroDocumento: numeroDocumento,
      ordenCompra: editarData.ordenCompra || '',
      serieDocumento: serieDocumento,
      tipoDocumento: tipoDocumento,
      tipoDocumentoSocio: editarData.tipoDocumentoSocio || '',
      tipoNota: editarData.tipoNota || '',
      tipoProducto: editarData.tipoProducto || TiposProductoConstant.BIEN,
      modificadoTipoDocumento: modificadoTipoDocumento,
      modificadoSerieDocumento: modificadoSerieDocumento,
      modificadoNumeroDocumento: modificadoNumeroDocumento
    }
  }, [
    editarData,
    flagSinEntrega,
    flagVentaRapida,
    flagNuevaNota,
    codigoTransaccion,
    __adminContext.fechaTrabajo,
    __adminContext.valoresConfiguracionUsuario.flagFacturacionConIGV,
    __adminContext.valoresConfiguracionSede._idListaPrecio
  ])

  const clickRecalcular = React.useCallback(() => {
    const incluyeIGV = mainFormikRef.current.values.incluyeIGV
    const montoAnticipo = mainFormikRef.current.values.montoAnticipo

    let sumaInafecto = 0
    let sumaExonerado = 0
    let sumaGratuito = 0
    let sumaGravado = 0
    let sumaIgv = 0
    let sumaDescuento = 0
    let sumaIcbper = 0
    let sumaAnticipo = 0
    let sumaTotal = 0
    let sumaTotalGravados = 0

    let detTotal = 0

    const fechaActual = new Date()
    const anoActual = `${fechaActual.getFullYear()}`
    let factorIcbper = MontosIcbper.montos[anoActual] || MontosIcbper.montos['2023']

    let detalle = null

    const nuevosDetalles = [...detalles].filter(x => !x.esFilaBusqueda)

    if (incluyeIGV) {
      for (let i = 0; i < nuevosDetalles.length; i++) {
        detalle = nuevosDetalles[i]
        detalle.subTotal = RounderUtil.roundTwoDecimals(detalle.subTotal)

        if (detalle.flagGratuito) {
          // Gratuito
          sumaGratuito = RounderUtil.round(sumaGratuito + parseFloat(detalle.total))
        } else if (
          !(
            (flagNota || mainFormikRef.current.values.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) &&
            mainFormikRef.current.values.tipoNota === '13'
          )
        ) {
          // Descuento
          sumaDescuento = RounderUtil.round(sumaDescuento + parseFloat(detalle.descuentoMonto || '0'))

          // Icbper
          sumaIcbper = RounderUtil.round(
            sumaIcbper + parseFloat(detalle.cantidad) * (detalle.flagBolsa ? factorIcbper : 0)
          )

          if (detalle.afectacion === '20') {
            sumaExonerado = RounderUtil.round(sumaExonerado + parseFloat(detalle.subTotal))
          } else if (detalle.afectacion === '30') {
            sumaInafecto = RounderUtil.round(sumaInafecto + parseFloat(detalle.subTotal))
          } else {
            // const igv = RounderUtil.round(parseFloat(detalle.subTotal) - parseFloat(detalle.subTotal) / 1.18)
            // const gravado = RounderUtil.round(parseFloat(detalle.subTotal) - igv)
            const igv = parseFloat(detalle.subTotal) - parseFloat(detalle.subTotal) / 1.18
            const gravado = parseFloat(detalle.subTotal) - igv

            // Igv
            // sumaIgv = RounderUtil.round(sumaIgv + parseFloat(igv || '0'))
            // sumaGravado = RounderUtil.round(sumaGravado + parseFloat(gravado || '0'))
            // sumaIgv = sumaIgv + parseFloat(igv || '0')
            sumaGravado = sumaGravado + parseFloat(gravado || '0')
            sumaTotalGravados = sumaTotalGravados + parseFloat(detalle.total)
          }

          // Total
          sumaTotal = sumaTotal + parseFloat(detalle.total)
        }
      }
    } else {
      for (let i = 0; i < nuevosDetalles.length; i++) {
        detalle = nuevosDetalles[i]

        if (detalle.flagGratuito) {
          // Gratuito
          sumaGratuito = RounderUtil.round(sumaGratuito + parseFloat(detalle.total))
        } else if (
          !(
            (flagNota || mainFormikRef.current.values.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) &&
            mainFormikRef.current.values.tipoNota === '13'
          )
        ) {
          // Descuento
          sumaDescuento = RounderUtil.round(sumaDescuento + parseFloat(detalle.descuentoMonto || '0'))

          // Icbper
          sumaIcbper = RounderUtil.round(
            sumaIcbper + parseFloat(detalle.cantidad) * (detalle.flagBolsa ? factorIcbper : 0)
          )

          if (detalle.afectacion === '20') {
            sumaExonerado = RounderUtil.round(sumaExonerado + parseFloat(detalle.subTotal))
          } else if (detalle.afectacion === '30') {
            sumaInafecto = RounderUtil.round(sumaInafecto + parseFloat(detalle.subTotal))
          } else {
            const gravado = RounderUtil.round(
              parseFloat(detalle.precioReferencia || detalle.precio) * parseFloat(detalle.cantidad)
            )
            const igv = RounderUtil.round(gravado * 0.18)

            // Igv
            sumaIgv = RounderUtil.round(sumaIgv + parseFloat(igv || '0'))
            sumaGravado = RounderUtil.round(sumaGravado + parseFloat(gravado || '0'))
            detTotal = RounderUtil.round(igv + gravado)
          }

          // Total
          sumaTotal = RounderUtil.round(sumaTotal + parseFloat(detTotal))
          detTotal = 0
        }
      }
    }
    sumaTotal = RounderUtil.roundTwoDecimals(sumaTotal)
    sumaIgv = RounderUtil.roundTwoDecimals(sumaTotalGravados - sumaTotalGravados / 1.18)

    if (montoAnticipo && nuevosDetalles.length > 0) {
      const primerDetalle = nuevosDetalles[0]
      sumaAnticipo = parseFloat(montoAnticipo)

      if (primerDetalle.afectacion === '10') {
        const igvAnticipo = RounderUtil.round(sumaAnticipo - sumaAnticipo / 1.18)
        const anticipoMontoBase = RounderUtil.round(sumaAnticipo - igvAnticipo)

        sumaGravado = RounderUtil.round(sumaGravado - anticipoMontoBase)
        sumaIgv = RounderUtil.round(sumaIgv - igvAnticipo)
        sumaTotal = RounderUtil.round(sumaTotal - sumaAnticipo)
      } else if (primerDetalle.afectacion === '20') {
        sumaExonerado = RounderUtil.round(sumaExonerado - sumaAnticipo)
        sumaTotal = RounderUtil.round(sumaTotal - sumaAnticipo)
      } else if (primerDetalle.afectacion === '30') {
        sumaInafecto = RounderUtil.round(sumaInafecto - sumaAnticipo)
        sumaTotal = RounderUtil.round(sumaTotal - sumaAnticipo)
      }
    }

    sumaTotal = RounderUtil.roundTwoDecimals(sumaTotal + sumaIcbper)

    resumenMontosRef.current = {
      sumaInafecto,
      sumaExonerado,
      sumaGratuito,
      sumaGravado: RounderUtil.roundTwoDecimals(sumaGravado),
      sumaIgv: RounderUtil.roundTwoDecimals(sumaIgv),
      sumaDescuento,
      sumaIcbper,
      sumaAnticipo,
      sumaTotal
    }

    setKeyResumenMontos(IdGen.newId())
    setMostrarBotonRecalcular(false)
  }, [detalles, flagNota])

  const reiniciarFormularioMontos = React.useCallback(() => {
    setMostrarBotonRecalcular(true)
    resumenMontosRef.current = RESUMEN_MONTOS_INITIAL_VALUES
    setKeyResumenMontos(IdGen.newId())
  }, [])

  const clickCalcularPromociones = React.useCallback(() => {
    const detallesPromocion = detalles.filter(x => x.flagPromocionOrigen)
    if (detallesPromocion.length === 0) {
      __zariContext.toast('warning', 'No se encontraron promociones disponibles.')
      return
    }

    const idsOrigen = [...new Set(detallesPromocion.map(x => x._idProductoPresentacion))]

    __zariContext.loader.open('Calculando promociones')

    PromocionService.obtenerxIdsProductoPresentacionOrigenAsInfoPromocion(idsOrigen)
      .then(({ data }) => {
        detallesDispatcher({ type: 'promociones', payload: data || [] })
      })
      .catch(() => {
        __zariContext.toast('error', 'No se pudo obtener información de las promociones.')
      })
      .finally(() => {
        __zariContext.loader.close()
        reiniciarFormularioMontos()
      })
  }, [__zariContext, detalles, reiniciarFormularioMontos])

  const clickAplicarTasaPorTarjeta = React.useCallback(() => {
    ZrSwal.showAlert({
      tipo: 'warning',
      mensaje: `Seguro que desea aplicar la tasa (${__adminContext.valoresConfiguracionCompania.tasaPorTarjeta}%) por tarjeta?`,
      showCerrar: true,
      onSuccess: () => {
        detallesDispatcher({
          type: 'aplicarTasas',
          payload: { tasaPorTarjeta: __adminContext.valoresConfiguracionCompania.tasaPorTarjeta }
        })
        reiniciarFormularioMontos()
        setKeyDetalles(IdGen.newId())
      }
    })
  }, [__adminContext, reiniciarFormularioMontos])

  const onDocumentoSeleccionado = React.useCallback(data => {
    submitDataRef.current = data

    if (data.condicionPago === CondicionesPagoConstant.CONTADO) {
      setMostrarFormularioPagosModal(true)
    } else {
      setMostrarAsignacionCuotasModal(true)
    }
  }, [])

  const submitFormularioPagos = React.useCallback(
    (formData, { setSubmitting } = {}) => {
      const necesitaDocumentoReferencia =
        formData.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO &&
        !formData.documentoManual &&
        !flagNuevaNota &&
        !formData._idDocumentoRelacionado &&
        !formData.modificadoSerieDocumento &&
        !editarData.detalles

      if (necesitaDocumentoReferencia) {
        setMostrarFormularioPagosModal(false)
        setMostrarAsignacionCuotasModal(false)
        setMostrarConsultarDocumentoModal(true)
        setSubmitting(false)
        return
      }

      if (
        formData.condicionPago === CondicionesPagoConstant.CREDITO &&
        formData.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO &&
        !formData.documentoManual &&
        !flagNuevaNota &&
        !formData._idDocumentoRelacionado &&
        !editarData.detalles
      ) {
        setMostrarAsignacionCuotasModal(false)
        setMostrarConsultarDocumentoModal(true)
        setSubmitting(false)
        return
      }
      const detallesGravados = formData.detalles.filter(x => x.afectacion === '10')
      const arrMontos = detallesGravados.map(x => x.gravado)
      const sumaDeMontos = RounderUtil.roundTwoDecimals(arrMontos.reduce((a, b) => a + b, 0))
      if (detallesGravados.length > 1 && sumaDeMontos !== formData.importeGravado) {
        formData.detalles = formData.detalles.filter(x => x.afectacion !== '10')
        detallesGravados[detallesGravados.length - 1] = {
          ...detallesGravados[detallesGravados.length - 1],
          gravado: RounderUtil.roundTwoDecimals(
            detallesGravados[detallesGravados.length - 1].gravado + (formData.importeGravado - sumaDeMontos)
          ),
          valorBrutoTotal: RounderUtil.roundTwoDecimals(
            detallesGravados[detallesGravados.length - 1].gravado + (formData.importeGravado - sumaDeMontos)
          )
        }
        formData = {
          ...formData,
          detalles: [...formData.detalles, ...detallesGravados]
        }
      }

      const submitFunction = formData._id
        ? flagAnular
          ? () => FacturacionService.anularFacturacionxId(formData._id, formData, flagAnular)
          : () => FacturacionService.actualizarFacturacionxId(formData._id, formData)
        : () => FacturacionService.nuevaFacturacion(formData)

      submitFunction()
        .then(({ data }) => {
          if (data.flagErrorContabilidad) {
            ZrSwal.showAlert({
              tipo: 'error',
              mensaje:
                'La venta no llego a contabilidad.Por favor contactese con el administrador. Haga click en "Aceptar" para cerrar sesion.',
              showCerrar: true,
              onSuccess: () => {
                history.push(`/logout`)
              }
            })
          } else {
            if (formData._id) {
              __zariContext.snack('success', 'El documento se ha guardado.')
              history.push(`/${CodigosTransaccionesConstant.VENTAS_LISTA}`)
            } else {
              pdfHashRef.current = data.hash
              setMostrarPreviewPdfModal(true)
            }
          }
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, history, flagAnular, flagNuevaNota, editarData]
  )

  const submitEditarComentarios = React.useCallback(() => {
    const formData = submitDataRef.current

    FacturacionService.actualizarComentariosxId(formData._id, formData)
      .then(() => {
        __zariContext.snack('success', 'El documento se ha actualizado.')
        history.push(`/${CodigosTransaccionesConstant.VENTAS_LISTA}`)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, history])

  const handleSubmit = React.useCallback(() => {
    const formData = mainFormikRef.current.values
    const setSubmitting = mainFormikRef.current.setSubmitting

    const nuevosDetalles = [...detalles].filter(x => !x.esFilaBusqueda)
    //Validacion Venta sin Stock
    if (!flagPermitirVentaSinStock) {
      for (let e = 0; e < nuevosDetalles.length; e++) {
        const detalleActual = nuevosDetalles[e]
        StockService.obtenerStockEnSedes(detalleActual._idProductoPresentacion)
          .then(({ data }) => {
            const stockSeleccionado = data.find(x => x._idSede === __adminContext.valoresConfiguracionSede._id)
            if (!stockSeleccionado) {
              __zariContext.snack('error', 'No se encontro la sede del producto' + detalleActual.nombreProducto)
              setSubmitting(false)
              return
            } else {
              if (parseFloat(stockSeleccionado.cantidad) < parseFloat(detalleActual.cantidad)) {
                __zariContext.snack('error', 'Insuficiente stock del producto: ' + detalleActual.nombreProducto)
                setSubmitting(false)
                return
              }
            }
          })
          .catch(({ data: { error } }) => {
            __zariContext.snack('error', error)
            setSubmitting(false)
            return
          })
      }
    }

    for (let i = 0; i < nuevosDetalles.length; i++) {
      const nuevoDet = nuevosDetalles[i]

      if (nuevoDet.flagGratuito && nuevoDet.afectacionBase !== '10') {
        __zariContext.snack('error', 'Solo se puede aplicar monto gratuito a productos con afectación 10.')
        setSubmitting(false)
        return
      }

      const tasaValidacionCosto = __adminContext.valoresConfiguracionCompania.tasaValidacionCosto

      if (tasaValidacionCosto && tasaValidacionCosto > 0 && !isNaN(tasaValidacionCosto)) {
        const innerCosto = nuevoDet.costo

        if (innerCosto && innerCosto > 0 && !isNaN(innerCosto)) {
          const innerPrecio = parseFloat(nuevoDet.precio || 0)
          const agregadoMinimoPrecio = RounderUtil.round((innerCosto * tasaValidacionCosto) / 100, 4)
          const minimoPrecio = RounderUtil.round(innerCosto + agregadoMinimoPrecio, 4)

          if (nuevoDet.monedaCosto === formData.moneda) {
            if (innerPrecio < minimoPrecio) {
              __zariContext.snack(
                'error',
                `El producto ${nuevoDet.codigoProducto} - ${nuevoDet.nombreProducto} presenta precio inferior a su costo validacion (${minimoPrecio})`
              )
              setSubmitting(false)
              return
            }
          } else {
            let minimoPrecioConvertido = 0
            if (formData.moneda === MonedasConstant.SOLES && nuevoDet.monedaCosto === MonedasConstant.DOLARES) {
              minimoPrecioConvertido = RounderUtil.round(__adminContext.ultimoTipoCambio * minimoPrecio, 4)
            } else if (formData.moneda === MonedasConstant.DOLARES && nuevoDet.monedaCosto === MonedasConstant.SOLES) {
              minimoPrecioConvertido = RounderUtil.round(minimoPrecio / __adminContext.ultimoTipoCambio, 4)
            }

            if (minimoPrecioConvertido !== 0) {
              if (innerPrecio < minimoPrecio) {
                __zariContext.snack(
                  'error',
                  `El producto ${nuevoDet.codigoProducto} - ${nuevoDet.nombreProducto} presenta precio inferior a su costo validacion (${minimoPrecio})`
                )
                setSubmitting(false)
                return
              }
            }
          }
        }
      }
    }

    const fechaActual = new Date()
    const anoActual = `${fechaActual.getFullYear()}`
    let factorIcbper = MontosIcbper.montos[anoActual] || MontosIcbper.montos['2023']

    const detallesNormalizados = nuevosDetalles.map(x => {
      let precio = 0
      let valorUnitario = 0
      let gravado = 0
      let exonerado = 0
      let inafecto = 0
      let valorBrutoTotal = 0
      let igv = 0
      let total = 0
      let precioReferencia = 0

      let descuentoConIGV = 0
      let descuentoSinIGV = 0
      let descuentoIGV = 0

      let icbper = parseFloat(x.cantidad) * (x.flagBolsa ? factorIcbper : 0)
      if (
        !(
          (flagNota || mainFormikRef.current.values.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) &&
          mainFormikRef.current.values.tipoNota === '13'
        )
      ) {
        if (x.afectacion === '10' || x.afectacion === '11') {
          if (formData.incluyeIGV) {
            precio = parseFloat(x.precio || 0)
            precioReferencia = precio
            valorUnitario = RounderUtil.round(parseFloat(x.precio || 0) / 1.18, 5)
            igv = RounderUtil.roundTwoDecimals(parseFloat(x.subTotal) - parseFloat(x.subTotal) / 1.18)
            gravado = RounderUtil.roundTwoDecimals(parseFloat(x.subTotal) - igv)
            valorBrutoTotal = gravado
            total = parseFloat(x.total)
          } else {
            valorUnitario = parseFloat(x.precio || 0)
            precio = RounderUtil.roundTwoDecimals(valorUnitario * 1.18)
            precioReferencia = precio
            gravado = parseFloat(x.subTotal || 0)
            valorBrutoTotal = gravado
            igv = RounderUtil.roundTwoDecimals(gravado * 0.18)
            total = RounderUtil.roundTwoDecimals(gravado + igv)
          }
        } else if (x.afectacion === '20') {
          valorUnitario = parseFloat(x.precio || 0)
          precio = RounderUtil.round(valorUnitario)
          precioReferencia = precio
          exonerado = parseFloat(x.subTotal || 0)
          valorBrutoTotal = exonerado
          igv = 0
          total = exonerado
        } else if (x.afectacion === '30') {
          valorUnitario = parseFloat(x.precio || 0)
          precio = RounderUtil.roundTwoDecimals(valorUnitario)
          precioReferencia = precio
          inafecto = parseFloat(x.subTotal || 0)
          valorBrutoTotal = inafecto
          igv = 0
          total = inafecto
        }

        if (formData.incluyeIGV) {
          descuentoConIGV = parseFloat(x.descuentoMonto ?? 0)
          descuentoSinIGV = RounderUtil.round(x.descuentoMonto / 1.18, 5)
          descuentoIGV = RounderUtil.round(descuentoConIGV - descuentoSinIGV, 5)
        } else {
          descuentoSinIGV = parseFloat(x.descuentoMonto ?? 0)
          descuentoIGV = RounderUtil.round(descuentoSinIGV * 0.18, 5)
          descuentoConIGV = RounderUtil(descuentoSinIGV + descuentoIGV, 5)
        }
      }

      return {
        _id: x._id,
        _idCentroCostoNivel1: x._idCentroCostoNivel1,
        _idCentroCostoNivel2: x._idCentroCostoNivel2,
        _idProductoPresentacion: x._idProductoPresentacion,
        _idPlacaSocio: __adminContext.valoresConfiguracionCompania.flagGrifo ? x._idPlacaSocio : formData._idPlacaSocio,
        cantidad: parseFloat(x.cantidad || 0),
        precio: precio,
        valorUnitario: valorUnitario,
        gravado: gravado,
        exonerado: exonerado,
        inafecto: inafecto,
        valorBrutoTotal: valorBrutoTotal,
        icbper: icbper,
        igv: igv,
        total: total,
        precioReferencia: precioReferencia,
        descuentoConIGV: descuentoConIGV,
        descuentoSinIGV: descuentoSinIGV,
        descuentoIGV: descuentoIGV,
        comentario: x.comentario,
        flagGratuito: x.flagGratuito,
        afectacion: x.afectacion,
        flagAnticipo: x.flagAnticipo
      }
    })

    if (detallesNormalizados.length === 0) {
      __zariContext.snack('error', 'No se han registrado detalles.')
      setSubmitting(false)
      return
    }

    const submitData = {
      ...formData,
      _idSocio: formData._idSocio || idClienteVariosRef.current,
      numeroDocumento: parseFloat(formData.numeroDocumento),
      detalles: detallesNormalizados,
      importeDescuento: parseFloat(resumenMontosRef.current.sumaDescuento),
      importeGratuito: parseFloat(resumenMontosRef.current.sumaGratuito),
      importeGravado: parseFloat(resumenMontosRef.current.sumaGravado),
      importeInafecto: parseFloat(resumenMontosRef.current.sumaInafecto),
      importeExonerado: parseFloat(resumenMontosRef.current.sumaExonerado),
      importeIgv: parseFloat(resumenMontosRef.current.sumaIgv),
      importeIcbper: parseFloat(resumenMontosRef.current.sumaIcbper),
      importeTotal: parseFloat(resumenMontosRef.current.sumaTotal)
    }

    if (
      submitData.tipoDocumento === TiposDocumentoSunatConstant.BOLETA &&
      submitData.tipoDocumentoSocio !== TiposDocumentoIdentificacionConstant.DNI &&
      submitData.importeTotal > 700
    ) {
      __zariContext.snack('error', 'Boleta con monto mayor a 700 debe ser asignado a un DNI.')
      setSubmitting(false)
      return
    }

    if (
      submitData.tipoProducto === TiposProductoConstant.SERVICIO &&
      submitData.tipoDocumento === TiposDocumentoSunatConstant.FACTURA &&
      submitData.importeTotal > 700 &&
      !submitData.codigoDetraccion
    ) {
      __zariContext.snack('error', 'Facturación de servicios con monto mayor a S/ 700.00 requiere de detracción.')
      setSubmitting(false)
      return
    }

    submitDataRef.current = submitData

    if (flagEditarComentarios) {
      submitEditarComentarios()
    } else {
      const esNotaCreditoSinReferencia =
        submitData.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO &&
        !flagNuevaNota &&
        !submitData._idDocumentoNota &&
        !submitData.modificadoSerieDocumento

      if (esNotaCreditoSinReferencia) {
        setMostrarConsultarDocumentoModal(true)
      } else if (submitData.condicionPago === CondicionesPagoConstant.CONTADO) {
        setMostrarFormularioPagosModal(true)
      } else {
        setMostrarAsignacionCuotasModal(true)
      }
    }
  }, [
    flagNota,
    __zariContext,
    detalles,
    __adminContext.valoresConfiguracionCompania.flagGrifo,
    __adminContext.valoresConfiguracionCompania.tasaValidacionCosto,
    __adminContext.ultimoTipoCambio,
    __adminContext.valoresConfiguracionSede,
    flagEditarComentarios,
    flagPermitirVentaSinStock,
    submitEditarComentarios,
    flagNuevaNota
  ])

  const validarSerieContingencia = React.useCallback(() => {
    const formData = mainFormikRef.current.values
    const setSubmitting = mainFormikRef.current.setSubmitting

    FacturacionService.validarExistenciaDeNumeroAnterior({
      tipo: formData.tipoDocumento,
      serie: formData.serieDocumento,
      numero: formData.numeroDocumento
    }).then(({ data }) => {
      if (data) {
        handleSubmit()
      } else {
        ZrSwal.showAlert({
          tipo: 'warning',
          mensaje: 'No existe el numero de documento anterior. ¿Desea continuar?',
          showCerrar: true,
          onSuccess: () => {
            handleSubmit()
          },
          onClose: () => {
            setSubmitting(false)
          }
        })
      }
    })
  }, [handleSubmit])

  const onSubmit = React.useCallback(
    (formData, { setSubmitting } = {}) => {
      if (formData.flagSerieContingencia && formData.serieDocumento.startsWith('F')) {
        __zariContext.snack('error', 'La serie de contingencia no pueden empezar con la letra F.')
        setSubmitting(false)
        return
      }

      if (formData.serieDocumento.startsWith('1')) {
        __zariContext.snack('error', 'Las series no pueden empezar con el numero 1.')
        setSubmitting(false)
        return
      }

      if (/[a-zA-Z]/.test(formData.numeroDocumento)) {
        __zariContext.snack('error', 'El numero de documento no pueden contener letras.')
        setSubmitting(false)
        return
      }

      if (formData.numeroDocumento.length > 9) {
        __zariContext.snack('error', 'El numero de documento debe contener un maximo de 9 caracteres.')
        setSubmitting(false)
        return
      }

      // if (
      //   formData.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO &&
      //   formData.condicionPago !== CondicionesPagoConstant.CREDITO
      // ) {
      //   __zariContext.snack('error', 'El tipo de documento seleccionado solo puede ser efectuado en credito.')
      //   setSubmitting(false)
      //   return
      // }

      if (formData.flagSerieContingencia) {
        validarSerieContingencia()
      } else {
        handleSubmit()
      }
    },
    [__zariContext, validarSerieContingencia, handleSubmit]
  )

  React.useEffect(() => {
    if (flagEditar || flagNota || flagEditarComentarios || flagDuplicado) {
      if (!firstRefreshRef.current) {
        clickRecalcular()
        firstRefreshRef.current = true
      }
    }
    if (flagAnular) {
      reiniciarFormularioMontos()
    }
  }, [
    clickRecalcular,
    reiniciarFormularioMontos,
    flagEditar,
    flagNota,
    flagEditarComentarios,
    flagDuplicado,
    flagAnular
  ])

  React.useEffect(() => {
    SocioService.obtenerIdClienteVarios()
      .then(({ data }) => {
        idClienteVariosRef.current = data
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
    CompaniaService.self
      .getCompania()
      .then(({ data }) => {
        if (data) {
          setFlagPermitirVentaSinStock(data.flagPermitirVentaSinStock || false)
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, setFlagPermitirVentaSinStock])

  return (
    <>
      <Row>
        <Col md={12}>
          <Formik
            initialValues={formInitialValues}
            innerRef={mainFormikRef}
            onSubmit={onSubmit}
            validationSchema={ValidationSchema}
            validateOnMount={false}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({ errors, isSubmitting, touched, values, handleChange, handleSubmit, setFieldValue, setValues }) => (
              <Form>
                <Row>
                  <Col md={5} xl={4}>
                    <FormGroups.SocioFormGroup
                      iValue={values._idSocio}
                      values={values}
                      setValues={setValues}
                      iError={errors._idSocio}
                      flagGrifo={values.flagGrifo}
                    />
                    {values.tipoDocumentoSocio === TiposDocumentoIdentificacionConstant.OTROS && (
                      <FormGroups.NombreAlternativoSocioFormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors.nombreAlternativoSocio}
                        iTouched={touched.nombreAlternativoSocio}
                      />
                    )}
                    <FormGroups.DireccionSocioFormGroup
                      iError={errors._idDireccionSocio}
                      iTouched={touched._idDireccionSocio}
                      vIdSocio={values._idSocio}
                      fIsSubmitting={isSubmitting}
                      setFieldValue={setFieldValue}
                      flagEditarComentarios={flagEditarComentarios}
                    />
                    {values._idSocio && !flagSinEntrega ? (
                      <Row>
                        <Col md={3} />
                        <Col md={9}>
                          <Button onClick={() => setMostrarListaGuiasModal(true)} block tiny>
                            Mostrar Guias
                          </Button>
                        </Col>
                      </Row>
                    ) : null}
                    {flagNota && (
                      <FormGroups.DocumentoNotaFormGroup
                        iValue={`${values.modificadoTipoDocumento} - ${values.modificadoSerieDocumento} - ${values.modificadoNumeroDocumento}`}
                      />
                    )}
                    <Row>
                      <Col md={6}>
                        <FormGroups.FechaEmisionFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.fechaEmision}
                          iTouched={touched.fechaEmision}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                        />
                      </Col>
                      <Col md={6}>
                        <FormGroups.FechaVencimientoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.fechaVencimiento}
                          iTouched={touched.fechaVencimiento}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={4} xl={3}>
                    <Row>
                      <Col sm={6} md={12}>
                        <FormGroups.CondicionPagoFormGroup
                          mainFormikRef={mainFormikRef}
                          fIsSubmitting={isSubmitting}
                          iError={errors.condicionPago}
                          iTouched={touched.condicionPago}
                          flagNota={flagNota}
                          flagEditarComentarios={flagEditarComentarios}
                        />
                      </Col>
                      {__adminContext.valoresConfiguracionCompania.flagOrdenCompraEnVentas && (
                        <Col sm={6} md={12}>
                          <FormGroups.OrdenCompraFormGroup
                            fIsSubmitting={isSubmitting}
                            iError={errors.ordenCompra}
                            iTouched={touched.ordenCompra}
                            flagEditarComentarios={flagEditarComentarios}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col md={3} xl={2}>
                    <Row>
                      <Col sm={3} md={12}>
                        <FormGroups.TipoDocumentoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.tipoDocumento}
                          iTouched={touched.tipoDocumento}
                          flagEditarComentarios={flagEditarComentarios}
                          flagEditar={flagEditar}
                          flagNota={flagNota}
                        />
                      </Col>
                      <Col sm={6} md={12}>
                        <FormGroups.SerieNumeroFormGroup
                          fIsSubmitting={isSubmitting}
                          setFieldValue={setFieldValue}
                          flagEditar={flagEditar}
                          flagNuevaNota={flagNuevaNota}
                          vTipoDocumento={values.tipoDocumento}
                          vSerieDocumento={values.serieDocumento}
                          flagEditarComentarios={flagEditarComentarios}
                          vSerieReferencia={values.modificadoSerieDocumento}
                          flagSerieContingencia={values.flagSerieContingencia}
                        />
                      </Col>
                      <Col sm={3} md={12}>
                        <FormGroups.MonedaFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.moneda}
                          iTouched={touched.moneda}
                          flagEditarComentarios={flagEditarComentarios}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={3} xl={3}>
                    <FormGroups.IdListaPrecioFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idListaPrecio}
                      iTouched={touched._idListaPrecio}
                      setFieldValue={setFieldValue}
                      flagEditar={flagEditar}
                    />
                    {__adminContext.valoresConfiguracionCompania.flagContabilidad && (
                      <FormGroups.ModelosCuentas12FormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors._idModeloCuentas12}
                        iTouched={touched._idModeloCuentas12}
                        setFieldValue={setFieldValue}
                        flagEditar={flagEditar}
                        vCodigoTransaccion={values.codigoTransaccion}
                        iValue={values._idModeloCuentas12}
                      />
                    )}
                    <Row>
                      <Col md={12}>
                        <Button
                          outline
                          block
                          disabled={isSubmitting}
                          onClick={() => setMostrarListaPreVentasModal(true)}
                        >
                          Ver Pre Ventas
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Divider />
                {!flagEditarComentarios && (
                  <Row>
                    <Col xs={3}>
                      <FormGroups.TipoProductoFormGroup
                        fIsSubmitting={isSubmitting}
                        iValue={values.tipoProducto}
                        dispatch={detallesDispatcher}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                      />
                    </Col>
                    <Col xs={9} className='text-right'>
                      <Button disabled onClick={() => {}} color='danger' outline>
                        {values.moneda}
                      </Button>
                      {values._idSocio && (
                        <Button disabled={isSubmitting} onClick={() => setMostrarDocumentosAnticiposModal(true)}>
                          Anticipos
                        </Button>
                      )}
                    </Col>
                  </Row>
                )}
                <Sections.DetallesSection
                  key={__keyDetalles}
                  flagNota13={
                    (flagNota || values.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) &&
                    values.tipoNota === '13'
                  }
                  detalles={detalles}
                  dispatch={detallesDispatcher}
                  tipoProducto={values.tipoProducto}
                  tipoDocumento={values.tipoDocumento}
                  incluyeIGV={values.incluyeIGV}
                  idSocio={values._idSocio}
                  reiniciarFormularioMontos={reiniciarFormularioMontos}
                  flagPermitirVentaSinStock={flagPermitirVentaSinStock}
                  flagEditarComentarios={flagEditarComentarios}
                  idListaPrecio={values._idListaPrecio}
                />
                <Row className='mb-2'>
                  <Col md={12} className='text-right'>
                    {mostrarBotonRecalcular && (
                      <Button disabled={isSubmitting} onClick={clickRecalcular}>
                        Recalcular
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col md={5} className='order-3 order-md-1'>
                    <FormGroups.ComentarioFormGroup
                      iError={errors.comentario}
                      iTouched={touched.comentario}
                      fIsSubmitting={isSubmitting}
                    />
                    {!flagVentaRapida && (
                      <FormGroups.PlantillaComentarioFormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors._idPlantillaComentario}
                        iTouched={touched._idPlantillaComentario}
                      />
                    )}

                    <FormGroups.CodigoDetraccionFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.codigoDetraccion}
                      iTouched={touched.codigoDetraccion}
                    />

                    {values.idsAnticipos && values.idsAnticipos.length > 0 ? (
                      <FormGroups.AnticipoInfoFormGroup iValue={values.infosAnticipos} />
                    ) : null}

                    {flagNota || values.tipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO ? (
                      <>
                        <Divider noMargin />
                        <FormGroups.TipoNotaCreditoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.tipoNota}
                          iTouched={touched.tipoNota}
                        />
                        <FormGroups.MotivoFormGroup
                          fIsSubmitting={isSubmitting}
                          iError={errors.motivo}
                          iTouched={touched.motivo}
                        />
                      </>
                    ) : null}
                  </Col>
                  <Col md={2} className='order-1 order-md-2'>
                    {detalles.some(x => x.flagPromocionOrigen) && (
                      <Button outline disabled={isSubmitting} block onClick={clickCalcularPromociones}>
                        Calcular promociones
                      </Button>
                    )}
                    {__adminContext.valoresConfiguracionCompania.flagTasaPorTarjeta && (
                      <Button outline disabled={isSubmitting} block onClick={clickAplicarTasaPorTarjeta}>
                        Aplicar tasa por tarjeta
                      </Button>
                    )}
                  </Col>
                  <Col md={5} className='order-2 order-md-3'>
                    <Sections.ResumenMontosSection
                      key={__keyResumenMontos}
                      montos={resumenMontosRef.current}
                      flagVentaRapida={flagVentaRapida}
                    />
                  </Col>
                </Row>
                <Divider noMargin />
                <Row>
                  <Col md={12} className='text-right'>
                    <Button disabled={isSubmitting || mostrarBotonRecalcular} onClick={handleSubmit}>
                      Procesar
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
      {mostrarConsultarDocumentoModal && (
        <Modals.ConsultarDocumentoModal
          show={mostrarConsultarDocumentoModal}
          handleClose={() => setMostrarConsultarDocumentoModal(false)}
          mainFormData={submitDataRef.current}
          onDocumentoSeleccionado={onDocumentoSeleccionado}
        />
      )}
      {mostrarDocumentosAnticiposModal && (
        <Modals.DocumentosAnticiposModal
          show={mostrarDocumentosAnticiposModal}
          handleClose={() => setMostrarDocumentosAnticiposModal(false)}
          values={mainFormikRef.current.values}
          setValues={mainFormikRef.current.setValues}
          reiniciarFormularioMontos={reiniciarFormularioMontos}
        />
      )}
      {mostrarListaGuiasModal && (
        <Modals.ListaGuiasModal
          show={mostrarListaGuiasModal}
          handleClose={() => setMostrarListaGuiasModal(false)}
          idSocio={mainFormikRef.current.values._idSocio}
          setFieldValue={mainFormikRef.current.setFieldValue}
          dispatch={detallesDispatcher}
          reiniciarFormularioMontos={reiniciarFormularioMontos}
        />
      )}
      {mostrarListaPreVentasModal && (
        <Modals.ListaPreVentasModal
          show={mostrarListaPreVentasModal}
          handleClose={() => setMostrarListaPreVentasModal(false)}
          setFieldValue={mainFormikRef.current.setFieldValue}
          dispatch={detallesDispatcher}
          reiniciarFormularioMontos={reiniciarFormularioMontos}
        />
      )}
      {mostrarFormularioPagosModal && (
        <Modals.FormularioPagosModal
          handleClose={e => {
            setMostrarFormularioPagosModal(false)
            mainFormikRef.current.setSubmitting(false)
          }}
          show={mostrarFormularioPagosModal}
          submitData={submitDataRef.current}
          submitFunction={submitFormularioPagos}
        />
      )}
      {mostrarAsignacionCuotasModal && (
        <Modals.AsignacionCuotasModal
          handleClose={e => {
            setMostrarAsignacionCuotasModal(false)
            mainFormikRef.current.setSubmitting(false)
          }}
          show={mostrarAsignacionCuotasModal}
          mainFormData={submitDataRef.current}
          submitData={submitDataRef.current}
          submitFunction={submitFormularioPagos}
        />
      )}
      {mostrarPreviewPdfModal && (
        <Modals.PreviewPdfModal
          handleClose={() => setMostrarPreviewPdfModal(false)}
          show={mostrarPreviewPdfModal}
          reiniciarFormulario={reiniciarFormulario}
          pdfHash={pdfHashRef.current}
          flagSinEntrega={flagSinEntrega}
          flagVentaRapida={flagVentaRapida}
        />
      )}
    </>
  )
}

export default React.memo(EstandarView)
